export const HOME_PAGE_EVENTS = {
  VIEWED: "Home Viewed",
  FILTER_APPLIED: "Home Filter Applied"
};

export const HOME_PAGE_EVENTS_PARAMS = {
  CHANNEL: "channel",
  TIME_RANGE: "time_range"
};

export const ONBOARDING_BANNER_EVENTS = {
  ONBOARDING_BANNER_VIEWED: 'Onboarding Banner Viewed',
  COMPLETE_ONBOARDING_BTN_CLICK: 'Complete Onboarding Btn Clk',
  VIEW_ISSUES_BTN_CLICK: 'View Issues Btn Clk',
  SUPPORT_BTN_CLICK: 'Support Clk',
  VIEW_PAYMENT_STATUS_BTN_CLICK: 'View Payment Intg Status Btn Clk',
};

export const ONBOARDING_BANNER_PARAMS = {
  STATUS: 'status',
  MESSAGE: 'message',
  MERCHANT_ID: 'merchant_id',
  PHONE_NUMBER: 'phone_number',
  LANGUAGE: 'language',
  COUNTRY: 'country',
  PAGE_NAME: 'page_name',
  USER_ID: 'user_id',
};

export const ONBOARDING_BANNER_VALUES = {
  PAGE_NAME: 'new_dashboard_home',
}